/** Not-yet / never states for the detail page, all inside the chrome. */
import { ReviewError, ReviewLoading } from '../ReviewLoadStates';

import ReviewDetailShell from './ReviewDetailShell';

export default function ReviewDetailPlaceholder({
  isPhone,
  message,
}: {
  isPhone: boolean;
  message: string | null;
}) {
  return (
    <ReviewDetailShell crumb="Customers › Needs review" title="Needs review" isPhone={isPhone}>
      {message === null ? (
        <ReviewLoading label="Loading this flagged item" />
      ) : (
        <ReviewError message={message} />
      )}
    </ReviewDetailShell>
  );
}
